<ion-app>
  <app-loader></app-loader>

  <!-- Native app -->
  <ion-content *appShowOnPlatform="'android'">
    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)" class="ion-refresher-wrapper">
      <ion-refresher-content
        pullingIcon="chevron-down-circle-outline"
        refreshingSpinner="crescent"
      ></ion-refresher-content>
    </ion-refresher>
    <ion-router-outlet></ion-router-outlet>
  </ion-content>

  <!-- Web app -->
  <ion-content *appShowOnPlatform="'web'">
    <ion-router-outlet></ion-router-outlet>
  </ion-content>

  @if (showChat && chatType) {
    <app-chat-bubble
      [chatType]="chatType"
      [adjustChatBubblePosition]="adjustChatBubblePosition"
      [adjustChatBubblePositionXl]="adjustChatBubblePositionXl"
      (onChatOpen)="openChat()">
    </app-chat-bubble>
  }

</ion-app>
